export default {
  entities: {
    clientFixReason: {
      title: 'Tuzatish sababi',
    },
  },
};
